import { reactive, readonly, watch } from 'vue';
import { Locale } from 'vant';
import zhVant from 'vant/lib/locale/lang/zh-CN';
import enVant from 'vant/lib/locale/lang/en-US';
import ruVant from 'vant/lib/locale/lang/ru-RU';
import jaVant from 'vant/lib/locale/lang/ja-JP';
import koVant from 'vant/lib/locale/lang/ko-KR';
import zh from './zh-CN.json';
import en from './en-US.json';
import ru from './ru-RU.json';
import ja from './ja-JP.json';
import ko from './ko-KR.json';

export const messages = { 'zh-CN': zh, 'en-US': en, 'ru-RU': ru, 'ja-JP': ja, 'ko-KR': ko };
export const languages = [
  { code: 'zh-CN', label: '中文' },
  { code: 'en-US', label: 'English' },
  { code: 'ru-RU', label: 'Русский' },
  { code: 'ja-JP', label: '日本語' },
  { code: 'ko-KR', label: '한국어' },
];
const vantMessages = { 'zh-CN': zhVant, 'en-US': enVant, 'ru-RU': ruVant, 'ja-JP': jaVant, 'ko-KR': koVant };
const state = reactive({ code: 'zh-CN' });
export const language = readonly(state);

export function normalizeLanguage(value) {
  if (typeof value !== 'string') return '';
  const prefix = value.toLowerCase().split(/[-_]/)[0];
  return languages.find(({ code }) => code.split('-')[0] === prefix)?.code || '';
}

export function t(key, params = {}) {
  const text = messages[state.code][key] ?? zh[key] ?? key;
  return text.replace(/\{(\w+)\}/g, (match, name) => params[name] == null ? match : String(params[name]));
}

export function setLanguage(value) {
  const code = normalizeLanguage(value);
  if (!code) return false;
  state.code = code;
  document.documentElement.lang = code;
  Locale.use(code, vantMessages[code]);
  try { localStorage.setItem('h5-language', code); } catch (error) { /* 隐私模式下仍可在本页切换。 */ }
  return true;
}

export function installI18n(app, router) {
  let saved;
  try { saved = localStorage.getItem('h5-language'); } catch (error) { /* 存储不可用时使用浏览器语言。 */ }
  const query = new URLSearchParams(window.location.hash.split('?')[1] || '');
  const search = new URLSearchParams(window.location.search);
  const browserLanguage = (navigator.languages || [navigator.language]).map(normalizeLanguage).find(Boolean);
  setLanguage(normalizeLanguage(query.get('lang')) || normalizeLanguage(search.get('lang')) ||
    normalizeLanguage(saved) || browserLanguage || 'zh-CN');
  app.config.globalProperties.$t = t;
  app.config.globalProperties.$language = language;
  const title = (route) => { document.title = t(route.meta.title || 'pageMap'); };
  router.afterEach((route) => {
    if (route.query.lang) setLanguage(route.query.lang);
    title(route);
  });
  watch(() => state.code, () => {
    // 详情页标题沿用接口返回的景点名称。
    if (router.currentRoute.value.name !== 'detail') title(router.currentRoute.value);
  });
}
